var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListNormal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3333 0C16.5101 0 16.6797 0.070238 16.8047 0.195262C16.9298 0.320287 17 0.489856 17 0.666667V15.3333C17 15.5101 16.9298 15.6797 16.8047 15.8047C16.6797 15.9298 16.5101 16 16.3333 16H1.66667C1.48985 16 1.32029 15.9298 1.19526 15.8047C1.07024 15.6797 1 15.5101 1 15.3333V0.666667C1 0.489856 1.07024 0.320287 1.19526 0.195262C1.32029 0.070238 1.48985 0 1.66667 0H16.3333ZM14.3333 5.33333H6.33333V4H14.3333V5.33333ZM5 5.33333H3.66667V4H5V5.33333ZM6.33333 8.66667H14.3333V7.33333H6.33333V8.66667ZM5 8.66667H3.66667V7.33333H5V8.66667ZM6.33333 12H14.3333V10.6667H6.33333V12ZM5 12H3.66667V10.6667H5V12Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListNormal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-normal.822fbd94d0a8ac156cc0f910a1ccd2ff.svg";